<!-- <template>
	<v-container class="mb-0 pb-0">
		<v-row class="contentRow py-0 mb-0">
			<v-col>
				<v-breadcrumbs class="py-1 px-0 grey--text" :items="crumbs"></v-breadcrumbs>
				<v-btn class="my-2" color="secondary" small @click="$router.go(-1)" outlined><v-icon left small>fas fa-arrow-left</v-icon> Back</v-btn>
			</v-col>
		</v-row>
	</v-container>
</template>
<script>
export default {
	computed: {
		crumbs: function() {
            let pathArray = this.$route.path.split("/");
            pathArray.shift()
            let test = this.$route.matched.map((t)=>{
				let exact = (t.path.indexOf(':') == -1)
                return {path: t.path, text: t.meta.name, exact: exact}
            })
			return test;
		}
	}
};
</script> -->

<template>
	<v-container class="mb-0 pb-0">
		<v-row class="contentRow py-0 mb-0" v-if="false">
			<v-spacer />
			<v-col cols="3">
				<v-card
					width="100%"
					height="80px"
					class="ma-0 pt-2 text-center"
					v-bind:class="{
						portaldisabled: !auditUnlocked,
						audit: auditUnlocked && (onAudit || !onAny),
						grey: auditUnlocked && !onAudit && onAny
					}"
					v-bind:dark="auditUnlocked"
					v-bind:to="auditUnlocked ? '/audit' : null"
				>
					<v-img
						alt="Audit Icon"
						:src="require('../assets/Icon_Audit.svg')"
						:aspect-ratio="0.86"
						width="30px"
						class="mx-auto"
					/>
					<p
						class="font-weight-bold d-none d-sm-block"
						style="font-size: 1.2em"
					>
						Audit
					</p>
				</v-card>
			</v-col>
			<v-spacer />
			<v-col cols="3">
				<v-card
					width="100%"
					height="80px"
					class="ma-0 pt-2 text-center"
					v-bind:class="{
						portaldisabled: !auditOnsiteUnlocked,
						auditonsite: auditOnsiteUnlocked && (onAuditOnsite || !onAny),
						grey: auditOnsiteUnlocked && !onAuditOnsite && onAny
					}"
					v-bind:dark="auditOnsiteUnlocked"
					v-bind:to="auditOnsiteUnlocked ? '/auditonsite' : null"
				>
					<v-img
						alt="Audit Icon"
						:src="require('../assets/Icon_Audit.svg')"
						:aspect-ratio="0.86"
						width="30px"
						class="mx-auto"
					/>
					<p
						class="font-weight-bold d-none d-sm-block"
						style="font-size: 1.2em"
					>
						Audit Onsite
					</p>
				</v-card>
			</v-col>
			<v-spacer />
			<v-col cols="3">
				<v-card
					width="100%"
					height="80px"
					class="ma-0 pt-2 text-center"
					v-bind:class="{
						portaldisabled: !auditFlowDownUnlocked,
						auditflowdown: auditFlowDownUnlocked && (onAuditFlowDown || !onAny),
						grey: auditFlowDownUnlocked && !onAuditFlowDown && onAny
					}"
					v-bind:dark="auditFlowDownUnlocked"
					v-bind:to="auditFlowDownUnlocked ? '/auditflowdown' : null"
				>
					<v-img
						alt="Audit Icon"
						:src="require('../assets/Icon_Audit.svg')"
						:aspect-ratio="0.86"
						width="30px"
						class="mx-auto"
					/>
					<p
						class="font-weight-bold d-none d-sm-block"
						style="font-size: 1.2em"
					>
						Audit Flow-Down
					</p>
				</v-card>
			</v-col>
			<v-spacer />
			<v-col cols="3">
				<v-card
					width="100%"
					height="80px"
					class="ma-0 pt-2 text-center"
					v-bind:class="{
						portaldisabled: !traceUnlocked,
						trace: traceUnlocked && (onTrace || !onAny),
						grey: traceUnlocked && !onTrace && onAny
					}"
					v-bind:dark="traceUnlocked"
					v-bind:to="traceUnlocked ? '/trace' : null"
				>
					<v-img
						alt="Trace Icon"
						:src="require('../assets/Icon_Trace.svg')"
						:aspect-ratio="0.68"
						width="25px"
						class="mx-auto"
					/>
					<p
						class="font-weight-bold d-none d-sm-block"
						style="font-size: 1.2em"
					>
						Trace
					</p>
				</v-card>
			</v-col>
			<v-spacer />
			<!-- <v-col cols="3">
				<v-card
					width="100%"
					height="80px"
					class="ma-0 pt-2 text-center"
					v-bind:class="{
						chain: !onAny,
						grey: onAny
					}"
					dark
					to="/chain"
				>
					<v-img
						alt="Chain Icon"
						:src="require('../assets/Icon_Chain.svg')"
						:aspect-ratio="1"
						width="38px"
						class="mx-auto"
					/>
					<p
						class="font-weight-bold d-none d-sm-block"
						style="font-size: 1.2em"
					>
						Chain
					</p>
				</v-card>
			</v-col>
			<v-spacer /> -->
			<v-col cols="3">
				<v-card
					width="100%"
					height="80px"
					class="ma-0 pt-2 text-center"
					v-bind:class="{
						portaldisabled: !connectionsUnlocked,
						connections: connectionsUnlocked && (onConnections || !onAny),
						grey: connectionsUnlocked && !onConnections && onAny
					}"
					v-bind:dark="connectionsUnlocked"
					v-bind:to="connectionsUnlocked ? '/connections' : null"
				>
					<v-img
						alt="Connections Icon"
						:src="require('../assets/Icon_Connections.svg')"
						:aspect-ratio="1.43"
						width="55px"
						class="mx-auto"
					/>
					<p
						class="font-weight-bold d-none d-sm-block"
						style="font-size: 1.2em"
					>
						Connections
					</p>
				</v-card>
			</v-col>
			<v-spacer />
		</v-row>
		<v-row
			class="contentRow py-0 mb-0 d-none d-sm-flex"
			align="center"
			justify="center"
		>
			<v-col class="flex-grow-0  justify-center">
				<v-btn
					color="darkColor"
					class="my-auto align-center"
					@click="navigateToParent"
					outlined
				>
					<v-icon small>fas fa-arrow-left</v-icon>
				</v-btn>
			</v-col>
			<v-col>
				<v-breadcrumbs
					class="h-100 py-0 px-0"
					:items="crumbs"
					large
				></v-breadcrumbs>
			</v-col>
			<v-spacer />
			<v-col>
				<div
					class="py-0 px-0 mb-0 align-center text-right"
				>
					<v-menu
						offset-y
						class="h-100 mx-2"
						open-on-hover
						right
						v-model="teamMenuActive"
					>
						<template v-slot:activator="{ on, attrs }">
							<v-btn
								:ripple="false"
								v-bind="attrs"
								v-on="on"
								x-large
								height="auto"
								light
								elevation="0"
								outlined
								class="text-left py-2 px-4 text-transform-none rounded-lg"
							>
								<div class="pa-1 mr-3">
									<b>
										{{ clientName }} Team
									</b>
									<small style="display: block;">
										{{clientUserCount}}{{(clientUserCount == 0 ? "Overview" : (clientUserCount == 1 ? " member" : " members"))}}
									</small>
								</div>
								<v-icon right small v-if="teamMenuActive">
									fas fa-chevron-up
								</v-icon>
								<v-icon right small v-else>
									fas fa-chevron-down
								</v-icon>
							</v-btn>
						</template>
						<v-list class="py-0">
							<v-list-item to="/team">
								<v-list-item-title>See team members</v-list-item-title>
							</v-list-item>
						</v-list>
					</v-menu>
				</div>
			</v-col>
		</v-row>
	</v-container>
</template>
<script>
import store from "../store"
export default {
	data() {
		return {
			teamMenuActive: false
		}
	},
	computed: {
		crumbs: function() {
			let pathArray = this.$route.path.split("/")
			pathArray.shift()
			let notEmpty = this.$route.matched.filter(t => {
				return !!t.meta.name
			})
			let test = notEmpty.map(t => {
				let exact = t.path.indexOf(":") == -1
				return { path: t.path, text: t.meta.name, exact: exact }
			})
			return test
		},
		auditUnlocked() {
			return this.$accessToRoute("/audit")
		},
		auditOnsiteUnlocked() {
			return this.$accessToRoute("/auditonsite")
		},
		auditFlowDownUnlocked() {
			return this.$accessToRoute("/auditflowdown")
		},
		traceUnlocked() {
			return this.$accessToRoute({ name: "Trace" })
		},
		connectionsUnlocked() {
			return this.$accessToRoute("/connections")
		},
		onTrace() {
			return /^\/trace(?:\/(.*))?$/.test(this.$route.path)
		},
		onAudit() {
			return /^\/audit(?:\/(.*))?$/.test(this.$route.path)
		},
		onAuditOnsite() {
			return /^\/auditonsite(?:\/(.*))?$/.test(this.$route.path)
		},
		onAuditFlowDown() {
			return /^\/auditflowdown(?:\/(.*))?$/.test(this.$route.path)
		},
		onConnections() {
			return /^\/connections(?:\/(.*))?$/.test(this.$route.path)
		},
		onAny() {
			return this.onTrace || this.onAudit || this.onAuditOnsite || this.onAuditFlowDown || this.onConnections
		},
		hasParent() {
			/* console.log(this.$route)
			if (this.$route.matched.length >= 2 && !this.$route.matched[this.$route.matched.length-2].regex.test(this.$route.path)) {
				return true
			} else if (this.$route.matched.length > 2 && !this.$route.matched[this.$route.matched.length-3].regex.test(this.$route.path)) {
				return true
			} else {
				return false
			} */
			let thisRoute = this.$route.path
			if (thisRoute.charAt(-1) == "/") thisRoute.slice(0, -1)
			return thisRoute.split("/").length > 2
		},
		username() {
			return store.getters["user/getUser"].username
		},
		clientID() {
			return store.getters["user/getUser"].clientID
		},
		clientName() {
			return store.getters["user/getUser"].clientName
		},
		clientUserCount() {
			return store.getters["user/getUser"].clientUserCount
		}
	},
	methods: {
		navigateToParent() {
			const dynamicPaths = ["/csr/submissions", "/emissions"]
			
			
			if (dynamicPaths.some(path => this.$route.path.startsWith(path))) {
				this.$router.go(-2)
			} else {
				this.$router.go(-1)
			}

			/* if(this.hasParent && Number.isInteger(this.$route.path.lastIndexOf("/")+1)) {
				this.$router.push("/")
			}
			if (this.hasParent) {
				if (this.$route.path.charAt(-1) == "/") {
					this.$route.path.slice(0, -1)
				}
				var parts = this.$route.path.split("/")
				if (parts[parts.length - 1] == "") {
					parts.splice(parts.length - 2, 1)
				} else {
					parts.splice(parts.length - 1, 1)
				}
				let newPath = parts.join("/")
				if (newPath == "/audit/audits" || newPath == "/audit") {
					newPath = "/"
				}
				this.$router.push(newPath)
			} else {
				this.$router.push("/")
			} */
		}
	}
}
</script>
<style scoped>
.portaldisabled {
	background-color: #55555544 !important;
	background-image: linear-gradient(
		45deg,
		white 25%,
		#55555544 25.5%,
		#55555544 50%,
		white 50.5%,
		white 75%,
		#55555544 75.5%,
		#55555544
	);
	background-size: 20px 20px;
	background-repeat: repeat;
}

.h-100 {
	height: 100%;
}
.text-transform-none {
  text-transform:none !important;
}
</style>
